import React, { FC } from 'react';
import injectSheet from 'react-jss';
import classNames from 'classnames';
import styleSheet from './styles';

interface ButtonProps {
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  classes: any;
  disabled?: boolean;
  value?: string;
  buttonType?:
    | 'defaultRed'
    | 'defaultBlue'
    | 'defaultWhite'
    | 'defaultClear'
    | 'profile'
    | 'addNew'
    | 'primaryAction'
    | 'secondaryAction'
    | 'goBack';

  ariaLabel?: string;
  children?: any;
}

const DefaultButton: FC<ButtonProps> = (props: ButtonProps) => {
  const {
    ariaLabel,
    buttonType,
    disabled,
    value,
    children,
    onClick: propOnClick,
    classes,
  } = props;

  const clickHandler = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (propOnClick) propOnClick(e);
    return null;
  };

  return (
    <button
      type="button"
      aria-label={ariaLabel}
      aria-disabled={disabled}
      className={classNames(classes[buttonType], {
        [classes.disabledStyle]: disabled,
      })}
      value={value}
      onClick={disabled ? undefined : clickHandler}
      data-testid="defaultButton"
    >
      {children}
    </button>
  );
};

DefaultButton.defaultProps = {
  disabled: false,
  buttonType: 'defaultClear',
  onClick: () => {},
  value: '',
  ariaLabel: '',
  children: undefined,
};
// @ts-ignore Look into why this is causing a ts warning//
export default injectSheet(styleSheet)(DefaultButton);
